import { isConnectionFailure } from './connection-failure';
import { getErrorStatusCode } from './error-status';

/**
 * Whether a failure is worth another attempt: the engine was unreachable, the request timed out, or
 * the answer was 5xx. A 4xx is caused by the request itself, so retrying only reproduces it, and
 * anything that is not recognisably a fetch failure is left alone.
 *
 * Heuristic: the engine has no typed error codes on this path yet (`crates/error/src/codes.rs`),
 * so this reads the HTTP status and ofetch's error shape.
 */
export function isTransientError(error: unknown): boolean {
	const statusCode = getErrorStatusCode(error);

	if (statusCode !== undefined) return statusCode >= 500 && statusCode < 600;

	return isConnectionFailure(error);
}
